// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__30H65","header":"ClearentDisclaimer_header__38itS","inner":"ClearentDisclaimer_inner__3oOEk"};